<template>
    <div class="Aviso">
        <div class="libe_home_nav" v-if="scroll >= 88">
            <headNav :activeNav="'loan'"></headNav>
        </div>
        <div class="libe_home_wrap">
            <div class="libe_homenav" v-if="scroll < 88 ">
                <headNav :activeNav="'loan'"></headNav>
            </div>

            <div class="arrecredi_home_banner" style="height: 270px;">

            </div>

            <div class="bigContent">
                <div class="content">
                    <div style="width: 100%; height: 60px; font-size: 32px; font-weight: bold; color: #333333;">TÉRMINOS Y CONDICIONES</div>
                    <p>
                        Productos y servicios tepoztli, S.A. DE C.V. (en lo sucesivo “Productos”) a través de nuestro portal “https://www.amigocredi.com" (en lo sucesivo la “Página Web”), así como también dentro de la aplicación disponible para dispositivos móviles con sistema operativo Android, denominada “AmigoCredi” (en lo sucesivo la “Aplicación”), informa que al momento de solicitar un préstamo, el usuario otorga su consentimiento expreso e irrevocable, en primer lugar, al Aviso de Privacidad para el tratamiento de sus datos personales conforme a lo establecido en dicho aviso y, en segundo lugar, acepta someterse a los presentes Términos y Condiciones, aplicables al préstamo que podrá o no ser autorizado. Todos los documentos mencionados estarán disponibles para su consulta en la Página Web.
                    </p>
                    <p>
                        Se aclara expresamente que los productos y servicios ofrecidos por Productos están dirigidos exclusivamente a personas físicas mexicanas con capacidad legal para contratar, quedando excluidos menores de edad, personas declaradas judicialmente en estado de interdicción o aquellas sujetas a limitaciones por contratos, convenios o relaciones comerciales previas. Esta enumeración es ejemplificativa y no limitativa.
                    </p>
                    <p>
                        Los servicios ofrecidos por Productos a través de la Página Web y/o la Aplicación son válidos únicamente en el territorio de los Estados Unidos Mexicanos. En caso de que la Página Web o la Aplicación sean accesibles desde otros países, esto no implicará la autorización o habilitación de los servicios fuera de México.
                    </p>
                    <p>
                        Para mayor claridad, se detallan los siguientes Términos y Condiciones:
                    </p>
                    <p style="font-weight: bold;">1. ACEPTACIÓN</p>
                    <p>El usuario reconoce y acepta que, al ingresar y navegar en la Página Web y/o al registrarse mediante este medio o a través de la Aplicación, manifiesta su voluntad expresa e inequívoca de sujetarse a estos Términos y Condiciones, los cuales son obligatorios y vinculantes. En caso de no aceptarlos o no estar de acuerdo con el Aviso de Privacidad, deberá abstenerse de utilizar la Página Web o la Aplicación.</p>
                    <p>Es responsabilidad del usuario leer y comprender íntegramente las condiciones establecidas antes de realizar cualquier gestión o solicitar servicios.</p>

                    <p style="font-weight: bold;">2. USO ADECUADO Y RESTRICCIONES DEL SOFTWARE Y HARDWARE</p>
                    <p>El usuario acepta que, al acceder a la Aplicación o Página Web mediante cualquier dispositivo con conexión a Internet, se compromete a no utilizar herramientas que interfieran con su funcionamiento, bases de datos o información contenida.</p>
                    <p>Asimismo, el usuario es responsable de contar con:</p>
                    <ul>
                        <li>
                            Hardware y software compatibles.
                        </li>
                        <li>
                            Conexión a Internet estable.
                        </li>
                        <li>
                            Dispositivos técnicamente aptos para el correcto uso de los servicios.
                        </li>
                    </ul>
                    <p>
                        Si el acceso se realiza desde un dispositivo móvil, el usuario acepta que podrán aplicarse tarifas de datos y mensajes según su proveedor de red.
                    </p>
                    <p style="font-weight: bold;">3. RESTRICCIONES LEGALES EN MATERIA DE PREVENCIÓN DE LAVADO DE DINERO</p>
                    <p>Productos y el usuario se obligan a:</p>
                    <ul>
                        <li>
                            Garantizar que sus operaciones, empleados, socios y recursos no estén vinculados a actividades ilícitas, en particular lavado de activos o financiamiento al terrorismo.
                        </li>
                        <li>
                            En caso de detectarse dudas razonables sobre el origen de fondos o la inclusión en listas restrictivas (ONU, OFAC, etc.), Productos podrá rescindir unilateralmente el préstamo sin indemnización.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">4. REGISTRO, SOLICITUD DE PRÉSTAMO, OTORGAMIENTO Y PAGO</p>
                    <p style="font-weight: bold;">I. REGISTRO, CREACIÓN, INHABILITACIÓN Y CANCELACIÓN DE CUENTA</p>
                    <ul>
                        <li>
                            Todo usuario que desee solicitar productos o servicios deberá registrarse en la Aplicación o Página Web, proporcionando los datos requeridos.
                        </li>
                        <li>
                            El usuario es responsable de mantener la confidencialidad de su contraseña y de todas las operaciones realizadas desde su cuenta.
                        </li>
                        <p><span style="font-weight: bold;">Productos podrá suspender o inhabilitar cuentas si el usuario:</span></p>
                        <li>
                            Incumple las leyes o estos Términos y Condiciones.
                        </li>
                        <li>
                            Proporciona información falsa o no verificable.
                        </li>
                        <li>
                            Realiza actos fraudulentos.
                        </li>
                    </ul>
                    <p>
                        El usuario podrá cancelar su cuenta en cualquier momento, siempre que no tenga deudas pendientes.
                    </p>
                    <p style="font-weight: bold;">II. DATOS PERSONALES</p>
                    <p><span style="font-weight: bold;">El usuario deberá proporcionar:</span></p>
                    <ul>
                        <li>
                            Nombre completo, fecha de nacimiento, domicilio, teléfono de contacto.
                        </li>
                        <li>
                            Referencias personales y datos bancarios (en caso de aprobación del préstamo).
                        </li>
                    </ul>
                    <p>
                        Productos podrá consultar y almacenar los contactos del usuario para análisis de riesgo, garantizando que sean referencias crediticias válidas.
                    </p>
                    <p style="font-weight: bold;">III. CONFIRMACIÓN DE USUARIO Y RESTRICCIONES</p>
                    <ul>
                        <li>
                            El usuario recibirá un código de confirmación vía SMS para validar su identidad.
                        </li>
                        <li>
                            Deberá subir una foto de su INE (anverso y reverso) y una selfie para verificar su mayoría de edad y autenticidad.
                        </li>
                    </ul>
                    <p>
                        Productos se reserva el derecho de:
                    </p>
                    <ul>
                        <li>
                            Solicitar documentación adicional.
                        </li>
                        <li>
                            Suspender cuentas con datos alterados o falsificados.
                        </li>
                    </ul>
                    <p>
                        Cada cuenta es personal, única e intransferible. La detección de múltiples cuentas con datos coincidentes podrá resultar en su cancelación.
                    </p>
                    <p style="font-weight: bold;">IV. SOLICITUD DE PRÉSTAMO</p>
                    <ul>
                        <li>
                            El monto máximo autorizable es de $20,000.00 MXN, sujeto a historial crediticio.
                        </li>
                        <li>
                            No se considerará aprobado hasta que Productos lo notifique formalmente en la Aplicación o Página Web.
                        </li>
                    </ul>

                    <p style="font-weight: bold;">V. OBLIGACIÓN DE PAGO, PLAZOS E INTERESES</p>
                    <ul>
                        <li>
                            El préstamo genera intereses anuales sobre saldos insolutos.
                        </li>
                        <li>
                            En caso de mora, se aplicarán intereses moratorios hasta su liquidación.
                        </li>
                        <li>
                            El plazo mínimo de pago es de 8 días, pudiendo extenderse hasta 90 días según historial.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">VI. USO NO AUTORIZADO DE LA CUENTA</p>
                    <ul>
                        <li>
                            El usuario debe notificar inmediatamente cualquier acceso no autorizado.
                        </li>
                        <li>
                            Queda prohibida la venta, cesión o transferencia de la cuenta.
                        </li>
                    </ul>
                    <p>
                        Productos no se responsabiliza por:
                    </p>
                    <ul>
                        <li>
                            Errores tipográficos o negligencia del usuario.
                        </li>
                        <li>
                            Pérdida o robo de dispositivos con acceso a la cuenta.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">VII. PUBLICIDAD Y MERCADOTECNIA</p>
                    <p>
                        El usuario autoriza a Productos a enviarle publicidad y promociones por cualquier medio electrónico.
                    </p>
                    <p style="font-weight: bold;">VIII. PUBLICACIÓN DE TÉRMINOS Y CONDICIONES</p>
                    <p>
                        Los requisitos de contratación y términos actualizados están disponibles en: https://www.amigocredi.com
                    </p>
                    <p style="font-weight: bold;">IX. MODIFICACIONES DE LOS TÉRMINOS Y CONDICIONES</p>
                    <p>
                        Productos podrá actualizar estos términos, publicando los cambios en la Aplicación o Página Web. Si el usuario no está de acuerdo, deberá notificarlo por correo electrónico en un plazo de 5 días, so pena de considerarse aceptados tácitamente.
                    </p>
                    <p style="font-weight: bold;">X. PROPIEDAD INTELECTUAL</p>
                    <ul>
                        <li>
                            El usuario no adquiere derechos sobre la propiedad intelectual de Productos.
                        </li>
                        <li>
                            La marca "AmigoCredi" está en proceso de registro y su uso no autorizado está prohibido.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">XI. CONTACTO</p>
                    <p>Atención al cliente: 5585265083</p>
                    <p>Email: amigocredi.contacto@gmail.com</p>
                    <p>Horario: lunes a viernes de 9:00 a 18:30, sábado y domingo 9:00-14:30  </p>

                    <p style="font-weight: bold;">XII. NOTIFICACIONES, JURISDICCIÓN Y LEY APLICABLE</p>
                    <ul>
                        <li>
                            Todas las notificaciones se realizarán por correo electrónico.
                        </li>
                        <li>
                            Para efectos legales, el domicilio del usuario será el registrado en su cuenta.
                        </li>
                        <li>
                            Este contrato se rige por las leyes mexicanas, sometiéndose a la jurisdicción de los Tribunales de la Ciudad de México.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">XIII. AUTORIZACIÓN PARA CONSULTA DE HISTORIAL CREDITICIO</p>
                    <p>El usuario autoriza a Productos a consultar su historial crediticio en Sociedades de Información Crediticia (SIC) por un plazo de 3 años o mientras dure la relación jurídica.</p>
                    <p style="font-weight: bold;">XIV. CONSENTIMIENTO ELECTRÓNICO</p>
                    <p>El usuario podrá manifestar su aceptación a estos términos mediante medios electrónicos (OTP).</p>
                    <p>Al utilizar la Página Web y/o la Aplicación, el usuario confirma haber leído, entendido y aceptado en su totalidad los presentes Términos y Condiciones.</p>
                </div>
            </div>
        </div>
        <footPage></footPage>
    </div>
</template>

<script>

    import $ from 'jquery';
    import headNav from "@/components/headNav.vue";
    import footPage from "@/components/foot.vue";
    import "../components/scss/Aviso.scss";

    export default {
        name: "loan",
        components: { headNav, footPage },
        data() {
            return {
                scroll: 0,
                activeName: 'first',
            }
        },
        mounted(){
            document.documentElement.scrollTop = 0;
            window.addEventListener('scroll',this.handleScroll);
            if(this.$route.query.activeName){
                this.activeName = this.$route.query.activeName;
            }
            this.$nextTick(() => {
                $('.el-tabs__active-bar').css({
                    width: '150px'
                })
            });


        },
        methods: {
            handleClick(tab, event){
                console.log(tab)
                console.log(event)
                this.$nextTick(() => {
                    setTimeout(() => {
                        $('.el-tabs__active-bar').css({
                            width: '150px'
                        })
                    }, 100)
                });
            },
            handleScroll(){
                this.scroll = document.documentElement.scrollTop||document.body.scrollTop
            },
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll)
        }
    }
</script>

<style>
    .title p span {
        border-bottom: 3px solid #4e67f1;
    }
    .arrecredi_home_banner{
        width: 100%;
        height: 402px;
        position: relative;
        overflow: hidden;
        z-index: 2;
    }
    .bigContent .el-tabs__item{
        height: 58px;
        font-weight: bold;
        font-size: 32px;
        color: #262A48;
    }
    .bigContent .el-tabs__item:hover{
        color: #262A48;
    }
    .bigContent .el-tabs__active-bar{
        height: 3px;
        background: #262A48;
    }
    .bigContent .el-tabs__item.is-active{
        color: #262A48;
    }
    .bigContent .el-tabs__nav-wrap::after{
        height: 0;
    }
    #tab-first{
        width: 495px;
    }
    .arrecrediprivacidad_view{
        width: 100%;
        padding: 50px 0 0 0;
    }
</style>

